import { render, staticRenderFns } from "./Biennale.vue?vue&type=template&id=d10e6e04&"
import script from "./Biennale.vue?vue&type=script&lang=js&"
export * from "./Biennale.vue?vue&type=script&lang=js&"
import style0 from "./Biennale.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports